import React from "react";
import PdfListPage from "./PdfListPage";
import { useBul } from "./BulLayout";

export default function Notices() {
  const data = useBul();
  return (
    <PdfListPage
      eyebrow="Communications"
      title="Notices & Circulars"
      accent="blue"
      items={data.notices_general || []}
      testid="bul-notices"
      emptyMsg="No notices or circulars have been published yet."
    />
  );
}
